var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFdicLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.36 15.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003256;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3",
    className: "cls-1",
    points: "3.99 15.72 0 15.72 0 .07 8.2 .07 8.2 4.16 3.99 4.16 3.99 6.69 7.96 6.69 7.96 10.78 3.99 10.78 3.99 15.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    className: "cls-1",
    d: "m21.29,7.88C21.29.71,15.26.07,12.76.07h-4.02v15.64h4.02v-4.08s0-7.53,0-7.53c2.47,0,4.57.97,4.57,3.77s-2.1,3.77-4.57,3.77v4.08c3.11,0,8.53-.63,8.53-7.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect7",
    className: "cls-1",
    x: 21.98,
    y: 0.03,
    width: 3.99,
    height: 15.68
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    className: "cls-1",
    d: "m34.1,11.58c-1.91,0-3.5-1.66-3.5-3.7s1.58-3.71,3.5-3.71c1.75,0,2.66.99,3.26,2.29V.84s-1.76-.84-3.41-.84c-3.65,0-7.61,3.58-7.61,7.87,0,5.25,3.77,7.87,7.61,7.87,1.64,0,3.41-.84,3.41-.84v-5.57c-.72,1.32-1.52,2.24-3.26,2.24Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdicLogoBlue);
export default __webpack_public_path__ + "static/media/FdicLogoBlue.0b05f458113298f5b350125f1c5d504a.svg";
export { ForwardRef as ReactComponent };